import React from 'react'
import { Box, Button, Typography } from '@material-ui/core'
import {
  INCOMPLETE_STRIPE_SETUP_TIP,
  CHARGES_DISABLED_OR_ACCOUNT_DELETED_TIP,
  PAYOUTS_DISABLED_TIP,
} from 'utils/constants'
import { IconButtonCtaArrow } from 'components/atoms/icons'
import useStyles from './styles'

const PaymentAccountWarning = ({ paymentAccount, onOpen, isEditing }) => {
  const classes = useStyles()
  const { detailsSubmitted, chargesEnabled, payoutsEnabled, deletedAt } =
    paymentAccount || {}
  const isDeletedPaymentAccount =
    deletedAt != null || (isEditing && !paymentAccount)

  if (
    (!paymentAccount && !isEditing) ||
    (detailsSubmitted && chargesEnabled && payoutsEnabled)
  ) {
    return null
  }

  const ActionButton = () => {
    const handleOpen = event => {
      event.preventDefault()
      event.stopPropagation()
      onOpen()
    }

    return isDeletedPaymentAccount ? null : (
      <Button
        type="button"
        color="primary"
        variant="body2"
        endIcon={<IconButtonCtaArrow />}
        className={classes.actionButton}
        onMouseDown={handleOpen}
        onClick={handleOpen}
      >
        Complete Setup{' '}
      </Button>
    )
  }

  const getWarningBlocks = () => {
    const warningBlocks = []

    if (!detailsSubmitted && !isDeletedPaymentAccount) {
      warningBlocks.push(
        <Box
          key="details-not-submitted"
          p={1.5}
          mb={2}
          borderRadius={4}
          style={{ backgroundColor: '#f5f5f5' }}
        >
          <Typography variant="body1" gutterBottom>
            {INCOMPLETE_STRIPE_SETUP_TIP}
          </Typography>
          <ActionButton />
        </Box>,
      )
      return warningBlocks
    }

    if (!chargesEnabled || isDeletedPaymentAccount) {
      warningBlocks.push(
        <Box
          key="charges-not-enabled"
          p={1.5}
          mb={2}
          borderRadius={4}
          style={{ backgroundColor: '#feecea' }}
        >
          <Typography variant="body1" gutterBottom>
            {CHARGES_DISABLED_OR_ACCOUNT_DELETED_TIP}
          </Typography>
          <ActionButton />
        </Box>,
      )
    }
    if (!payoutsEnabled && !isDeletedPaymentAccount) {
      warningBlocks.push(
        <Box
          key="payouts-not-enabled"
          p={1.5}
          mb={2}
          borderRadius={4}
          style={{ backgroundColor: '#fef5e4' }}
        >
          <Typography variant="body1" gutterBottom>
            {PAYOUTS_DISABLED_TIP}
          </Typography>
          <ActionButton />
        </Box>,
      )
    }

    return warningBlocks
  }

  return <>{getWarningBlocks()}</>
}

export default PaymentAccountWarning
